export enum MetaTag {
  Alternate = 'alternate',
  Canonical = 'canonical',
  PageType = 'pageType'
}
